// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
export type TaxDetail_FederalTaxDetailFragment = { __typename?: 'FederalTaxDetail', _cacheKey: string, exemptionAvailable: CurrencyUSD, exemptionUsed: CurrencyUSD, grossEstate: CurrencyUSD, gstTaxDeductions?: CurrencyUSD | null, nonTaxableTransfers: CurrencyUSD, stateTaxDeductions?: CurrencyUSD | null, tax: CurrencyUSD, taxableAmount: CurrencyUSD, valuationDiscount?: CurrencyUSD | null };

export type TaxDetail_StateTaxDetailFragment = { __typename?: 'StateTaxDetail', _cacheKey: string, adjustedTaxableGifts: CurrencyUSD, apportionmentRatio?: Percent | null, ctTaxesPaid?: CurrencyUSD | null, exemptionAvailable: CurrencyUSD, exemptionUsed: CurrencyUSD, grossEstate: CurrencyUSD, inheritanceTaxCredit?: CurrencyUSD | null, isTaxableAmountOverCliff: boolean, nonTaxableTransfers: CurrencyUSD, stateCode?: Types.StateCode | null, stateDisclosure?: string | null, tax: CurrencyUSD, taxableAmount: CurrencyUSD, taxableEstate: CurrencyUSD, tentativeStateTax?: CurrencyUSD | null, valuationDiscount?: CurrencyUSD | null };

export type TaxDetail_GstTaxDetailFragment = { __typename?: 'GSTTaxDetail', _cacheKey: string, exemptionAvailable: CurrencyUSD, exemptionUsed: CurrencyUSD, tax: CurrencyUSD, taxableAmount: CurrencyUSD, totalTransferAmount: CurrencyUSD, valuationDiscount?: CurrencyUSD | null };

export type TaxDetail_GiftTaxDetailFragment = { __typename?: 'GiftTaxDetail', _cacheKey: string, exemptionUsed: CurrencyUSD, tax: CurrencyUSD, taxableGiftsMade: CurrencyUSD };

export type TaxDetail_StateGiftTaxDetailFragment = { __typename?: 'StateGiftTaxDetail', _cacheKey: string, ctTaxesPaid?: CurrencyUSD | null, exemptionUsed: CurrencyUSD, stateCode: Types.StateCode, tax: CurrencyUSD, taxableAmount: CurrencyUSD, taxableGiftsMade: CurrencyUSD };

export type TaxDetail_StateInheritanceTaxDetailFragment = { __typename?: 'StateInheritanceTaxDetail', _cacheKey: string, stateCode: Types.StateCode, stateDisclosure?: string | null, tax: CurrencyUSD, taxableAmount: CurrencyUSD, totalTransferAmount: CurrencyUSD, valuationDiscount?: CurrencyUSD | null, exemptionUsed: CurrencyUSD, federalEstateTaxDeduction?: CurrencyUSD | null, nonResidentStateTaxDeduction?: CurrencyUSD | null };

export const Operations = {
  Fragment: {
    TaxDetail_FederalTaxDetail: 'TaxDetail_FederalTaxDetail' as const,
    TaxDetail_StateTaxDetail: 'TaxDetail_StateTaxDetail' as const,
    TaxDetail_GSTTaxDetail: 'TaxDetail_GSTTaxDetail' as const,
    TaxDetail_GiftTaxDetail: 'TaxDetail_GiftTaxDetail' as const,
    TaxDetail_StateGiftTaxDetail: 'TaxDetail_StateGiftTaxDetail' as const,
    TaxDetail_StateInheritanceTaxDetail: 'TaxDetail_StateInheritanceTaxDetail' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const TaxDetail_FederalTaxDetailFragmentDoc = gql`
    fragment TaxDetail_FederalTaxDetail on FederalTaxDetail {
  _cacheKey
  exemptionAvailable
  exemptionUsed
  grossEstate
  gstTaxDeductions
  nonTaxableTransfers
  stateTaxDeductions
  tax
  taxableAmount
  valuationDiscount
}
    `;
export const TaxDetail_StateTaxDetailFragmentDoc = gql`
    fragment TaxDetail_StateTaxDetail on StateTaxDetail {
  _cacheKey
  adjustedTaxableGifts
  apportionmentRatio
  ctTaxesPaid
  exemptionAvailable
  exemptionUsed
  grossEstate
  inheritanceTaxCredit
  isTaxableAmountOverCliff
  nonTaxableTransfers
  stateCode
  stateDisclosure
  tax
  taxableAmount
  taxableEstate
  tentativeStateTax
  valuationDiscount
}
    `;
export const TaxDetail_GstTaxDetailFragmentDoc = gql`
    fragment TaxDetail_GSTTaxDetail on GSTTaxDetail {
  _cacheKey
  exemptionAvailable
  exemptionUsed
  tax
  taxableAmount
  totalTransferAmount
  valuationDiscount
}
    `;
export const TaxDetail_GiftTaxDetailFragmentDoc = gql`
    fragment TaxDetail_GiftTaxDetail on GiftTaxDetail {
  _cacheKey
  exemptionUsed
  tax
  taxableGiftsMade
}
    `;
export const TaxDetail_StateGiftTaxDetailFragmentDoc = gql`
    fragment TaxDetail_StateGiftTaxDetail on StateGiftTaxDetail {
  _cacheKey
  ctTaxesPaid
  exemptionUsed
  stateCode
  tax
  taxableAmount
  taxableGiftsMade
}
    `;
export const TaxDetail_StateInheritanceTaxDetailFragmentDoc = gql`
    fragment TaxDetail_StateInheritanceTaxDetail on StateInheritanceTaxDetail {
  _cacheKey
  stateCode
  stateDisclosure
  tax
  taxableAmount
  totalTransferAmount
  valuationDiscount
  exemptionUsed
  federalEstateTaxDeduction
  nonResidentStateTaxDeduction
}
    `;